import { render, staticRenderFns } from "./ModalsConfirmAction.vue?vue&type=template&id=668972bc&scoped=true&"
import script from "./ModalsConfirmAction.vue?vue&type=script&lang=js&"
export * from "./ModalsConfirmAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668972bc",
  null
  
)

export default component.exports